<template>
  <div>
    <h3>Documents</h3>
    <hr>
    <button v-if="editAccess" class="mylisting-button dark-button mb-3" @click="showUploadDocumentsModal()">
      Upload Documents
    </button>
    <!-- <p>{{ user.resume }}</p> -->
    <div class="row">
      <div class="col-lg-4" v-if="editAccess">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">CPR & First Aid<span v-if="user.file2"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>

          <a v-if="user.file2" style="color: white;" :href="user.file2" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <div class="" v-else>
            <button class="mylisting-button dark-button" @click="showUploadDocumentsModal()">Upload</button>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="editAccess">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Resume<span v-if="user.resume"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>

          <a v-if="user.resume" style="color: white;" :href="user.resume" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <div class="" v-else>
            <button class="mylisting-button dark-button" @click="showUploadDocumentsModal()">Upload</button>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="editAccess">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">State ID<span v-if="user.file3"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>

          <a v-if="user.file3" style="color: white;" :href="user.file3" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <div class="" v-else>
            <button class="mylisting-button dark-button" @click="showUploadDocumentsModal()">Upload</button>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="editAccess">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Educational Certification<span v-if="user.file4"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>

          <a v-if="user.file4" style="color: white;" :href="user.file4" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <!-- <div class="" v-if="$store.getters.isAgent === true && !user.file4"> -->
          <div class="" v-else>
            <button class="mylisting-button dark-button" @click="showUploadDocumentsModal()">Upload</button>
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="editAccess">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Trustline<span v-if="user.file1"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>

          <a v-if="user.file1" style="color: white;" :href="user.file1" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <div class="" v-else>
            <button class="mylisting-button dark-button" @click="showUploadDocumentsModal()">Upload</button>
          </div>
        </div>
      </div>

      <div class="col-lg-4" v-if="user.file5 && ($store.getters.isAgent === true || $store.getters.isEmployer === true)">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">Background Check<span v-if="user.file5"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>

          <a v-if="user.file4" style="color: white;" :href="user.file5" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <div class="" v-if="$store.getters.isAgent === true && !user.file5">
            <button class="mylisting-button dark-button" @click="showUploadDocumentsModal()">Upload</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="editAccess" class="row">
      <div v-if="documents.length" class="col-lg-12">
        <h4 class="mt-3">Sign Documents</h4>
      </div>

      <div v-for="document in documents" :key="document.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <div v-if="!document.template">
            <h5 class="mb-3">{{ document.title }}<span v-if="document.status == 'Signed'"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>
            <button v-if="document.title == 'Code of Conduct' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showCodeOfConductModal(document)">Sign</button>
            <button v-if="document.title == 'Code of Conduct' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showCodeOfConductModal(document)">View</button>
            <button v-if="document.title == 'Background Check' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showBackgroundCheckModal(document)">Sign</button>
            <button v-if="document.title == 'Background Check' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showBackgroundCheckModal(document)">View</button>
            <button v-if="document.title == 'Nanny Handbook' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showNannyHandbookModal(document)">Sign</button>
            <button v-if="document.title == 'Nanny Handbook' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showNannyHandbookModal(document)">View</button>
            <button v-if="document.title == 'Distracted Driving' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showDistractedDrivingModal(document)">Sign</button>
            <button v-if="document.title == 'Distracted Driving' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showDistractedDrivingModal(document)">View</button>
            <button v-if="document.title == 'Covid Policies' && document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showCovidPoliciesModal(document)">Sign</button>
            <button v-if="document.title == 'Covid Policies' && document.status == 'Signed'" class="mylisting-button dark-button" @click="showCovidPoliciesModal(document)">View</button>

            <!-- <button class="mylisting-button danger-button" @click="deleteDocument(document)">Delete</button> -->
            <!-- <button class="mylisting-button danger-button" @click="unsignDocument(document)">Unsign</button> -->
          </div>

          <div v-if="document.template">
            <!-- {{ document }} -->
            <h5 class="mb-3">{{ document.title }}<span v-if="document.status == 'Signed'"><i style="font-size: 11px; margin-left: 5px; color: #444;" class="material-icons mt-1">check_circle</i></span></h5>
            <button v-if="document.status == 'Unsigned'" class="mylisting-button dark-button" @click="showDocumentModal(document)">Sign</button>
            <button v-if="document.status == 'Signed'" class="mylisting-button dark-button" @click="showDocumentModal(document)">View</button>
            <!-- <button v-if="$store.getters.isAgent === true" class="mylisting-button danger-button" @click="deleteDocument(document)">Delete</button> -->
          </div>

          <p v-if="$store.getters.isAgent === true" class="delete-text mt-2" @click="showDeleteDocumentModal(document)">Delete</p>
        </div>
      </div>

      <div v-if="files.length" class="col-lg-12 mt-3">
        <h4>Additional Documents</h4>
      </div>
      <div v-for="file in files" :key="file.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">{{ file.name }}</h5>
          <a style="" :href="file.file_link" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <p class="delete-text mt-3" @click="showDeleteFileModal(file)">Remove File</p>
        </div>
      </div>
      <div class="col-lg-12 mt-3">
        <button v-if="editAccess" class="mylisting-button dark-button mb-3" @click="showUploadFileModal()">Upload Additional Documents</button>
      </div>
    </div>

    <modal name="code-of-conduct-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <code-of-conduct :user="user" :document="document" @documentSigned="documentSigned()"></code-of-conduct>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('code-of-conduct-modal')">Close</button>
      </div>
    </modal>

    <modal name="background-check-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <background-check :user="user" :document="document" @documentSigned="documentSigned()"></background-check>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('background-check-modal')">Close</button>
      </div>
    </modal>

    <modal name="nanny-handbook-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <nanny-handbook :user="user" :document="document" @documentSigned="documentSigned()"></nanny-handbook>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('nanny-handbook-modal')">Close</button>
      </div>
    </modal>

    <modal name="distracted-driving-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <distracted-driving :user="user" :document="document" @documentSigned="documentSigned()"></distracted-driving>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('distracted-driving-modal')">Close</button>
      </div>
    </modal>

    <modal name="covid-policies-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <covid-policies :user="user" :document="document" @documentSigned="documentSigned()"></covid-policies>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('covid-policies-modal')">Close</button>
      </div>
    </modal>

    <modal name="document-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <document :user="user" :document="document" @documentSigned="documentSigned()"></document>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-modal')">Close</button>
        <!-- <button class="mylisting-button secondary-button float-right" v-if="document.signing_name" @click="downloadPDF()">Download PDF</button> -->
      </div>
    </modal>

    <modal name="document-signed-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your document has been signed.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('document-signed-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="upload-documents-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Upload Documents</h2>
        <hr>
        <p>You don't need to upload them all at once.</p>
        <div class="">
          <div class="row mb-4">
            <div class="col-lg-4">
              <label style="">CPR & First Aid*</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file2" ref="file2" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">State ID*</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="resume" ref="file3" v-on:change="handleFileUpload()"/>
            </div>
            <!-- <div class="col-lg-4" v-if="$store.getters.isAgent === true"> -->
            <div class="col-lg-4">
              <label style="">Educational Certification*</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="resume" ref="file4" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Resume</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="resume" ref="resume" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Trustline (California Only)</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file1" ref="file1" v-on:change="handleFileUpload()"/>
            </div>

            <div class="col-lg-4" v-if="$store.getters.isAgent === true">
              <label style="">Background Check</label>
              <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="resume" ref="file5" v-on:change="handleFileUpload()"/>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-lg-4">
              <label style="">Driver's Abstract Report*</label>
              <input type="file" class="form-control-file4" style="font-size: 0.8rem;" id="file4" ref="file4" v-on:change="handleFileUpload()"/>
            </div>
            <div class="col-lg-4">
              <label style="">Additional Education Document/Certificate (Not Required)</label>
              <input type="file" class="form-control-file5" style="font-size: 0.8rem;" id="file5" ref="file5" v-on:change="handleFileUpload()"/>
            </div>
          </div> -->
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('upload-documents-modal')" style="">Close</button>
        <button class="mylisting-button dark-button" style="float: right;" @click="uploadDocuments()">Upload</button>
      </div>
    </modal>

    <modal name="documents-uploaded-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Documents uploaded.</h2>
        <p>It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!</p>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('documents-uploaded-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-document-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Are you sure you want to delete the document {{ document.title }}?</h3>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-document-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteDocument(document)">Delete Document</button>
      </div>
    </modal>

    <modal name="upload-file-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Upload any additional files such as additional resumes, letters of recommendation, educational certificates, etc.</h3>
          <label style="">File Name*</label>
          <input type="text" class="form-control mb-2" v-model="fileName" placeholder="What name do you want to appear with this file?">
          <input type="file" class="form-control-file" style="font-size: 0.8rem;" id="file" ref="file" v-on:change="handleSingleFileUpload()"/>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('upload-file-modal')" style="">Close</button>
        <button v-if="fileName && file" class="mylisting-button dark-button" style="float: right;" @click="uploadFile()">Upload File</button>
      </div>
    </modal>

    <modal name="delete-file-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <h3>Are you sure you want to delete the file {{ selectedFile.name }}?</h3>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-file-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteFile(selectedFile)">Delete File</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

import CodeOfConduct from '../documents/CodeOfConduct'
import BackgroundCheck from '../documents/BackgroundCheck'
import CovidPolicies from '../documents/CovidPolicies'
import DistractedDriving from '../documents/DistractedDriving'
import NannyHandbook from '../documents/NannyHandbook'

import Document from './Document'

export default {
  props: ['user'],
  components: {
    CodeOfConduct,
    BackgroundCheck,
    CovidPolicies,
    DistractedDriving,
    NannyHandbook,
    Document,
  },
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    }
  },
  data() {
    return {
      documents: [],
      document: {},

      files: [],
      file: '',
      fileName: '',
      selectedFile: {},
    }
  },
  created() {
    this.getDocuments()
    this.getFiles()
  },
  methods: {
    getDocuments() {
      axios.get(`/api/documents/?signing_user=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.documents = res.data
          this.documents = this.documents.sort((a, b) => (a.id > b.id) ? 1 : -1)
        })
    },
    showCodeOfConductModal(document) {
      this.document = document
      this.$modal.show('code-of-conduct-modal')
    },
    showBackgroundCheckModal(document) {
      this.document = document
      this.$modal.show('background-check-modal')
    },
    showNannyHandbookModal(document) {
      this.document = document
      this.$modal.show('nanny-handbook-modal')
    },
    showDistractedDrivingModal(document) {
      this.document = document
      this.$modal.show('distracted-driving-modal')
    },
    showCovidPoliciesModal(document) {
      this.document = document
      this.$modal.show('covid-policies-modal')
    },
    showDocumentModal(document) {
      this.document = document
      this.$modal.show('document-modal')
    },
    documentSigned() {
      this.getDocuments()
      this.$modal.hide('code-of-conduct-modal')
      this.$modal.hide('background-check-modal')
      this.$modal.hide('nanny-handbook-modal')
      this.$modal.hide('distracted-driving-modal')
      this.$modal.hide('covid-policies-modal')
      this.$modal.hide('document-modal')
      this.$modal.show('document-signed-modal')

      this.$store.dispatch('sendEmails',
        {
          subject: `Document Signed - ${this.user.first_name} ${this.user.last_name} | ${this.document.title}`,
          message: 'Hello,' + '\n\n' +
          `The candidate ${this.user.first_name} ${this.user.last_name} just signed the following document: ${this.document.title}\n\n`+
          'Cheers!',
          from: this.$store.getters.agencyFromEmail,
          emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail2],
          reply: this.$store.getters.agencyAdminEmail2,
          // userID: this.aakashid,
          userID: 4,
        }
      )
    },
    showUploadDocumentsModal() {
      this.$modal.show('upload-documents-modal')
    },
    handleFileUpload() {
      this.resume = this.$refs.resume.files[0];
      this.file1 = this.$refs.file1.files[0];
      this.file2 = this.$refs.file2.files[0];
      this.file3 = this.$refs.file3.files[0];
      this.file4 = this.$refs.file4.files[0];
      this.file5 = this.$refs.file5.files[0];
    },
    uploadDocuments() {
      let formData = new FormData();
      if (this.resume) {
        formData.append("resume", this.resume);
      }
      if (this.file1) {
        formData.append("file1", this.file1);
      }
      if (this.file2) {
        formData.append("file2", this.file2);
      }
      if (this.file3) {
        formData.append("file3", this.file3);
      }
      if (this.file4) {
        formData.append("file4", this.file4);
      }
      if (this.file5) {
        formData.append("file5", this.file5);
      }

      this.$modal.hide('upload-documents-modal')
      this.$modal.show('documents-uploaded-modal')

      axios.patch("/api/people/".concat(this.user.id.toString()).concat("/"),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(res => {
          // console.log(res);
          // this.$modal.hide('upload-documents-modal')
          // this.$modal.show('documents-uploaded-modal')
          this.$emit('infoSaved')

          this.$store.dispatch('sendEmails',
            {
              subject: `Documents Uploaded - ${this.user.first_name} ${this.user.last_name}`,
              message: 'Hello,' + '\n\n' +
              `The nanny ${this.user.first_name} ${this.user.last_name} just uploaded new documents!\n\n`+
              'Cheers!',
              from: this.$store.getters.agencyFromEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail2],
              reply: this.$store.getters.agencyAdminEmail2,
              // userID: this.aakashid,
              userID: 4,
            }
          )

          // if (this.file3) {
          //   this.$store.dispatch('sendEmails',
          //     {
          //       subject: `Agency Resume Uploaded - ${this.user.first_name} ${this.user.last_name}`,
          //       message: 'Hello,' + '\n\n' +
          //       `The nanny ${this.user.first_name} ${this.user.last_name} just uploaded their agency resume!\n\n`+
          //       'Cheers!',
          //       from: this.$store.getters.agencyFromEmail,
          //       emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail3],
          //       reply: this.$store.getters.agencyReplyEmail,
          //       // userID: this.aakashid,
          //       userID: 4,
          //     }
          //   )
          // }
        })
        .catch(error => {
          console.log(error)
        })
    },

    showDeleteDocumentModal(document) {
      this.document = document
      this.$modal.show('delete-document-modal')
    },
    deleteDocument(document) {
      axios.delete(`/api/documents/${document.id}/`)
        .then(res => {
          this.getDocuments()
          this.$modal.hide('delete-document-modal')
        })
        .catch(error => console.log(error))
    },
    unsignDocument(document) {
      axios.patch(`/api/documents/${document.id}/`, {
        status: 'Unsigned',
        signing_name: '',
      })
        .then(res => {
          this.getDocuments()
        })
        .catch(error => console.log(error))
    },

    handleSingleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    getFiles() {
      axios.get(`/api/files/?user=${this.user.id}`)
        .then(res => {
          this.files = res.data
        })
        .catch(error => console.log(error))
    },
    showUploadFileModal() {
      this.file = ''
      this.fileName = ''
      this.$modal.show('upload-file-modal')
    },
    uploadFile() {
      axios.post(`/api/files/`, {
        user: this.user.id,
        name: this.fileName,
      })
        .then(res => {
          let formData = new FormData();
          if (this.file) {
            formData.append("file_link", this.file);
          }
          axios.patch(`/api/files/${res.data.id}/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          )
            .then(res => {
              this.getFiles()
              this.$modal.hide('upload-file-modal')
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    showDeleteFileModal(file) {
      this.selectedFile = file
      this.$modal.show('delete-file-modal')
    },
    deleteFile(file) {
      axios.delete(`/api/files/${file.id}`)
        .then(res => {
          this.$modal.hide('delete-file-modal')
          this.getFiles()
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/Documents.vue